import React from 'react';
import { motion } from 'framer-motion';
import { Tabs, TabsContent, TabsList, TabsTrigger } from './ui/tabs';
import { Globe, Smartphone, Monitor } from 'lucide-react';

export const Platforms = () => {
  return (
    <section id="platforms" className="py-16 sm:py-20" style={{ background: '#F7F7FB' }} data-testid="platforms-section">
      <div className="container-main">
        <div className="text-center mb-12">
          <p className="font-mono-accent text-xs font-medium uppercase tracking-[0.18em] text-[#7C3AED] mb-3">
            Platforms
          </p>
          <h2 className="text-2xl sm:text-3xl font-semibold tracking-tight text-[#0B0B10] mb-4">
            Available everywhere you need it
          </h2>
          <p className="text-base text-[#64647A] max-w-lg mx-auto">
            Access TexSolution from any device with full feature parity.
          </p>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="max-w-2xl mx-auto"
        >
          <Tabs defaultValue="web" data-testid="platforms-tabs">
            <TabsList className="grid w-full grid-cols-3 bg-white border border-[#E7E7EF] rounded-xl h-12">
              <TabsTrigger value="web" className="rounded-lg text-sm data-[state=active]:bg-[#7C3AED] data-[state=active]:text-white">
                <Monitor className="h-4 w-4 mr-2" />
                Web
              </TabsTrigger>
              <TabsTrigger value="ios" className="rounded-lg text-sm data-[state=active]:bg-[#7C3AED] data-[state=active]:text-white">
                <Smartphone className="h-4 w-4 mr-2" />
                iOS
              </TabsTrigger>
              <TabsTrigger value="android" className="rounded-lg text-sm data-[state=active]:bg-[#7C3AED] data-[state=active]:text-white">
                <Smartphone className="h-4 w-4 mr-2" />
                Android
              </TabsTrigger>
            </TabsList>

            <TabsContent value="web" className="mt-6">
              <div className="bg-white border border-[#E7E7EF] rounded-2xl p-6 sm:p-8 text-center">
                <div className="h-12 w-12 rounded-xl bg-[#F5F3FF] text-[#7C3AED] flex items-center justify-center mx-auto mb-4">
                  <Globe className="h-6 w-6" />
                </div>
                <h3 className="text-lg font-semibold text-[#0B0B10] mb-2">Web application</h3>
                <p className="text-sm text-[#64647A] mb-4">Access your wallet directly from any modern browser. No installation required. Full dashboard with analytics, transfers, and account management.</p>
                <div className="flex flex-wrap justify-center gap-2">
                  <span className="font-mono-accent text-xs bg-[#F7F7FB] px-2 py-1 rounded">Chrome</span>
                  <span className="font-mono-accent text-xs bg-[#F7F7FB] px-2 py-1 rounded">Firefox</span>
                  <span className="font-mono-accent text-xs bg-[#F7F7FB] px-2 py-1 rounded">Safari</span>
                  <span className="font-mono-accent text-xs bg-[#F7F7FB] px-2 py-1 rounded">Edge</span>
                </div>
              </div>
            </TabsContent>

            <TabsContent value="ios" className="mt-6">
              <div className="bg-white border border-[#E7E7EF] rounded-2xl p-6 sm:p-8 text-center">
                <div className="h-12 w-12 rounded-xl bg-[#F5F3FF] text-[#7C3AED] flex items-center justify-center mx-auto mb-4">
                  <Smartphone className="h-6 w-6" />
                </div>
                <h3 className="text-lg font-semibold text-[#0B0B10] mb-2">iOS app</h3>
                <p className="text-sm text-[#64647A] mb-4">Native iOS application with Face ID, push notifications, and Apple Pay integration. Optimized for iPhone and iPad.</p>
                <div className="flex flex-wrap justify-center gap-2">
                  <span className="font-mono-accent text-xs bg-[#F7F7FB] px-2 py-1 rounded">iOS 16+</span>
                  <span className="font-mono-accent text-xs bg-[#F7F7FB] px-2 py-1 rounded">Face ID</span>
                  <span className="font-mono-accent text-xs bg-[#F7F7FB] px-2 py-1 rounded">Apple Pay</span>
                </div>
                <p className="text-xs text-[#A78BFA] mt-4">Coming Q2 2026</p>
              </div>
            </TabsContent>

            <TabsContent value="android" className="mt-6">
              <div className="bg-white border border-[#E7E7EF] rounded-2xl p-6 sm:p-8 text-center">
                <div className="h-12 w-12 rounded-xl bg-[#F5F3FF] text-[#7C3AED] flex items-center justify-center mx-auto mb-4">
                  <Smartphone className="h-6 w-6" />
                </div>
                <h3 className="text-lg font-semibold text-[#0B0B10] mb-2">Android app</h3>
                <p className="text-sm text-[#64647A] mb-4">Full-featured Android application with biometric login, NFC payments, and Google Pay support. Works on Android 12 and above.</p>
                <div className="flex flex-wrap justify-center gap-2">
                  <span className="font-mono-accent text-xs bg-[#F7F7FB] px-2 py-1 rounded">Android 12+</span>
                  <span className="font-mono-accent text-xs bg-[#F7F7FB] px-2 py-1 rounded">Biometric</span>
                  <span className="font-mono-accent text-xs bg-[#F7F7FB] px-2 py-1 rounded">Google Pay</span>
                </div>
                <p className="text-xs text-[#A78BFA] mt-4">Coming Q3 2026</p>
              </div>
            </TabsContent>
          </Tabs>
        </motion.div>
      </div>
    </section>
  );
};
